import {
  parseUpcomingOrdersForIndexTable,
} from "@vendor-app/app/AdminRoute/AdminSubscriptionDetailsRoute/libs";
import React from "react";

type UpcomingOrderInfo = ReturnType<typeof parseUpcomingOrdersForIndexTable>[number];

export const UpcomingOrdersContext = React.createContext<UpcomingOrderInfo[]>([]);
